import { Flex, Grid } from "@aircall/tractor";
import { useNoInformationRule } from "@/hooks/useNoInformationRule/useNoInformationRule";
import { AutoScrollProvider } from "@/providers/AutoScrollContext/AutoScrollProvider";
import { Header } from "../Header/Header";
import { NoInformation } from "../NoInformation/NoInformation";
import { Player } from "../Player/Player";
import { SectionDetails } from "../SectionDetails/SectionDetails";
import { Transcription } from "../Transcription/Transcription";

export function MobileLayout() {
  const { hasNoInformation } = useNoInformationRule();

  // Same rule as the desktop Body: a call with no recording and no
  // transcription shows the no-information state instead of the media UI,
  // while the details section (Call info, Notes) stays reachable (CI-6448).
  return (
    <Grid gridTemplateRows="auto 1fr auto" h="100vh">
      <Header mobile />
      <AutoScrollProvider>
        <Flex flexDirection="column" overflow="auto">
          <SectionDetails mobile />
          {hasNoInformation ? <NoInformation /> : <Transcription mobile />}
        </Flex>
        {!hasNoInformation && <Player mobile />}
      </AutoScrollProvider>
    </Grid>
  );
}
